/*
 * cart-drawer-second-jersey.js — « Proposer le 2e maillot » (PDF Consignes-Panier 31/07)
 * ---------------------------------------------------------------------------
 * Quand le tiroir de panier contient EXACTEMENT 1 maillot, on propose le second
 * directement dans le tiroir, sans jamais en sortir :
 *
 *   Chemin 1 — LE MÊME modèle, en CARTE (variante « C4 », 19/08) :
 *       [photo] Borussia Dortmund          coin « 2e MAILLOT »
 *               Extérieur 2026/27
 *               [S][M][L][XL][2XL]   24,99€ 17,50€  (+)
 *       ── Ajouter un nom et un numéro ────────────────── ›
 *          (déplié) [apercu du dos] [Nom] [N°][Sous le n°]
 *                                   [ Ajouter 17,50 € ]
 *     · taille INDÉPENDANTE de celle du 1er maillot (52 % des paniers « même
 *       modèle » ont deux tailles différentes)
 *     · flocage indépendant (73 % des paniers floqués ont deux noms différents)
 *     · aucun choix de produit : c'est le modèle déjà au panier
 *
 *   Chemin 2 — UN AUTRE modèle :
 *     · la RANGÉE de vignettes sous le bloc, qui charge le maillot dans la
 *       carte au tap — sans popup et sans quitter le tiroir ;
 *     · la tuile « +N » ouvre la grille, qui n'est que cette rangée en plus
 *       grand : elle CHOISIT, elle ne configure pas. La taille et le flocage
 *       se règlent toujours sur la carte.
 *
 * Ce qu'on NE fait PAS (contraintes explicites du PDF) :
 *   · pas d'application ANTICIPÉE du code — le minimum du palier est de 2
 *     articles, le poser sur un panier d'UN article échoue et le client clique
 *     dans le vide. ⚠️ La contrainte porte sur l'INSTANT, pas sur le principe :
 *     depuis le 23/08 le code est posé APRÈS l'ajout, une fois le 2e maillot
 *     dans le panier — donc au moment où il est valide. Avant, la carte
 *     annonçait 17,50 € et le maillot entrait à 24,99 € ; il fallait trouver
 *     un second bouton « Appliquer » ailleurs dans le tiroir pour que le prix
 *     promis devienne le prix payé. Un prix affiché est une promesse.
 *   · pas de redirection hors du tiroir ;
 *   · pas de texte supplémentaire — une action, pas un discours.
 *
 * Contrainte de hauteur (§6 du PDF) : le bloc est volontairement compact pour
 * que « Aller à la page de paiement » reste atteignable sans scroller.
 */
(function () {
  'use strict';

  var root = document.getElementById('onix-second-jersey');
  if (!root || root.dataset.sjInit === '1') return;
  root.dataset.sjInit = '1';

  var T = {
    size: root.dataset.tSize || 'Taille',
    name: root.dataset.tName || 'Nom',
    number: root.dataset.tNumber || 'N°',
    below: root.dataset.tBelow || 'Sous le n°',
    apNom: root.dataset.tApNom || 'Nom',
    apNum: root.dataset.tApNum || 'N°',
    apSous: root.dataset.tApSous || 'Sous le n°',
    flocOpen: root.dataset.tFlocOpen || 'Ajouter un nom et un numéro',
    flocClose: root.dataset.tFlocClose || 'Nom et numéro',
    flocLabel: root.dataset.tFlocLabel || 'Flocage',
    add: root.dataset.tAdd || 'Ajouter',
    other: root.dataset.tOther || 'Choisir un autre maillot',
    deuxEtoiles: root.dataset.tDeuxEtoiles || '2 étoiles',
    ou: root.dataset.tOu || 'ou',
    auPanier: root.dataset.tAuPanier || 'au panier',
    otherTitle: root.dataset.tOtherTitle || 'Choisis ton 2e maillot',
    close: root.dataset.tClose || 'Fermer',
    error: root.dataset.tError || 'Ajout impossible — réessaie.',
    soldout: root.dataset.tSoldout || 'Épuisé',
  };
  var rootPath = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  /* ── prix du 2e maillot : fourni par Liquid (déjà remisé), sinon calcul ──
     Le PDF impose d'afficher le prix APRÈS remise (17,50 €) et jamais 24,99 €
     avec la remise « qui arrivera plus tard ». */
  var SECOND_CENTS = parseInt(root.dataset.secondPriceCents, 10) || 0;

  /* Le prix d'un maillot, LU dans l'attribut que le Liquid publie. Ma première
     version le dérivait de SECOND_CENTS (1750 / 0,7 = 2500) : le maillot vaut
     2499, et ce centime fermait l'offre pour tout le catalogue — mesuré. Une
     valeur que le serveur connaît ne se reconstruit pas côté client.
     Tolérance de 2 centimes quand même : c'est un arrondi Shopify qui décide,
     pas nous. */
  var UNITE_CENTS = parseInt(root.dataset.unitPriceCents, 10) || 0;
  var _sousTotalPanier = 0;   /* renseigné par refresh(), lu par peindre() */

  /* ── LE TAUX DU PALIER — 30/08 ────────────────────────────────────────────
     ⚠️ Il vient de `#onix-promo-suggest`, PROPRIÉTAIRE des paliers dans ce thème
       (documenté plus bas dans ce fichier). On le lit, on ne le recopie pas :
       un taux dupliqué diverge le jour où il change.
     ⚠️ Pas besoin de lire le sous-total du panier : ce bloc ne s'affiche QUE
       quand le panier contient exactement UN article (voir refresh()). Le
       sous-total, c'est donc cet article-là, et `refresh` l'a déjà en main.
       Ma première version allait chercher `[data-cart-subtotal-cents]` et
       `[data-line-price-cents]` — deux attributs que j'avais inventés et qui
       n'existent NULLE PART dans ce thème. La fonction aurait rendu 0 à chaque
       appel, sans erreur, et le prix aurait été faux d'une autre façon.
       Vérifié avant de pousser, pas après. */
  /* ⚠️ ELLE A LU DU VIDE PENDANT DES SEMAINES — constaté le 03/09. Le code
     ci-dessous cherche `t.pct` depuis son écriture, mais `data-tiers` ne portait
     que `qty`, `label` et `code` : AUCUN appel n'a jamais atteint la ligne du
     `pct`, tous tombaient sur le 0.15 en dur. Ça ne se voyait pas, parce que le
     palier 2 articles vaut justement 15 % — la panne rendait la bonne valeur.
     Depuis le 03/09, `data-tiers` porte `pct` et cette fonction lit enfin sa
     donnée. Vérifié : elle rend toujours 0,15 sur le data-tiers livré, et suit
     désormais le réglage si le palier change.
     ➜ Un repli qui coïncide avec la vraie valeur est invisible. Le seul moyen
       de le voir était de tester la fonction contre le data-tiers réel. */
  function tauxPalierCourant() {
    var el = document.getElementById('onix-promo-suggest');
    var brut = el && el.dataset ? el.dataset.tiers : null;
    if (!brut) return 0.15;                     /* palier 2 articles par défaut */
    var tiers;
    try { tiers = JSON.parse(brut); } catch (e) { return 0.15; }
    if (!Array.isArray(tiers) || !tiers.length) return 0.15;
    var t = tiers.filter(function (x) { return (x.qty || x.n || 0) <= 2; }).pop();
    if (t && t.pct != null) return Number(t.pct) > 1 ? Number(t.pct) / 100 : Number(t.pct);
    return 0.15;
  }
  function estAuPrixMaillot(cents) {
    /* ⛔ LE REPLI FERME L'OFFRE, IL NE L'OUVRE PLUS — 29/08.
       Il disait `return true` : attribut absent, on ne bloque rien. C'est le
       repli silencieux que CLAUDE.md interdit — une garde qui s'efface quand sa
       donnée manque protège exactement tant que rien ne va mal. Le coût d'une
       offre affichée à tort (un prix faux annoncé au client) est bien plus élevé
       que celui d'une offre manquante. En cas de doute, on se tait. */
    if (!UNITE_CENTS) return false;
    return Math.abs(cents - UNITE_CENTS) <= 2;
  }

  /* Le palier atteint UNE FOIS le 2e maillot ajouté. La table des paliers vit à
     UN SEUL endroit — l'attribut data-tiers de #onix-promo-suggest — et on la
     lit plutôt que d'écrire « onix3 » en dur : le jour où un palier change, il
     ne change qu'à cet endroit. Repli sur onix3 si le bloc n'est pas rendu. */


  function fmt(cents) {
    var cur = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'EUR';
    var a = (cents || 0) / 100;
    if (cur === 'EUR') return a.toFixed(2).replace('.', ',') + '€';
    try { return new Intl.NumberFormat('en', { style: 'currency', currency: cur, currencyDisplay: 'narrowSymbol' }).format(a); }
    catch (e) { return a.toFixed(2) + ' ' + cur; }
  }

  /* ── état ── */
  var currentHandle = null;   // handle du produit au panier (exclu de la grille)
  var currentProduct = null;  // objet produit (variantes)
  var busy = false;

  /* ── LA RANGÉE DE MAILLOTS ───────────────────────────────────────────
     `_liste`   les alternatives, dans l'ORDRE EXACT de la grille popup —
                sinon le compte de la tuile ment et le client retrouve dans
                la grille les vignettes qu'il vient de voir ;
     `_choisi`  le handle affiché par la CARTE. Au départ c'est celui du
                panier ; il change dès qu'on tape une vignette. */
  var _liste = [];
  var _choisi = null;
  /* ⚠️ L'IMAGE DU MAILLOT DU PANIER SE GARDE À PART. Elle était lue sur
     `currentProduct`, qui désigne le maillot AFFICHÉ — donc dès le premier
     tap, la vignette « au panier » montrait le maillot qu'on venait de
     choisir. Deux vignettes identiques côte à côte, dont une étiquetée
     « au panier » : le client ne pouvait plus retrouver le sien. */
  var _imgPanier = '';
  /* ⚠️ ET SES TAGS AUSSI. Le badge ★★ de la vignette « au panier » était lu
     sur `currentProduct` — le maillot AFFICHÉ. Dès qu'on choisissait un PSG
     deux étoiles, le Borussia héritait du badge et se retrouvait décoré d'une
     distinction qu'il n'a pas. Même piège que l'image, deux heures plus tôt,
     au même endroit et pour la même raison. */
  var _fichePanier = { tags: [], title: '' };

  var elImg = root.querySelector('[data-sj-img]');
  var elPill = root.querySelector('[data-sj-pill]');
  var elClub = root.querySelector('[data-sj-club]');
  var elSous = root.querySelector('[data-sj-soustitre]');
  var elSizes = root.querySelector('[data-sj-sizes]');
  var elCompare = root.querySelector('[data-sj-compare]');
  var elPrice = root.querySelector('[data-sj-price]');
  var elPlus = root.querySelector('[data-sj-add-nu]');
  var elToggle = root.querySelector('[data-sj-toggle]');
  var elBandTxt = root.querySelector('[data-sj-bandeau-txt]');
  var elBandVal = root.querySelector('[data-sj-bandeau-val]');
  var elPan = root.querySelector('[data-sj-pan]');
  var elDos = root.querySelector('[data-sj-dos]');
  var elApNom = root.querySelector('[data-sj-apercu-nom]');
  var elApNum = root.querySelector('[data-sj-apercu-num]');
  var elApSous = root.querySelector('[data-sj-apercu-sous]');
  var elName = root.querySelector('[data-sj-name]');
  var elNumber = root.querySelector('[data-sj-number]');
  var elBelow = root.querySelector('[data-sj-below]');
  var elAdd = root.querySelector('[data-sj-add]');
  var elAddPrice = root.querySelector('[data-sj-add-price]');
  var elAddCompare = root.querySelector('[data-sj-add-compare]');
  var elRangee = root.querySelector('[data-sj-rangee]');
  var elErr = root.querySelector('[data-sj-error]');

  /* La taille choisie. Il n'y a plus de <select> : le rang de boutons (T2)
     montre les tailles sans un geste et barre les ruptures, ce qu'un menu ne
     peut pas faire tant qu'il est fermé. */
  var varianteId = null;

  function setError(show) {
    if (!elErr) return;
    if (show) elErr.removeAttribute('hidden'); else elErr.setAttribute('hidden', '');
  }

  /* ── T2 : les tailles en RANG, pas un menu ────────────────────────────
     Toutes visibles sans un geste, ruptures barrées et non cliquables. Un
     menu fermé ne dit ni ce qui existe ni ce qui manque. */
  /* ⚠️ LA VARIANTE SE LIT AU MOMENT D'AGIR, elle ne se souvient pas.
     `varianteId` est une variable de module : tout ce qui re-rend le bloc passe
     par fillSizes() qui la remet à null. Le bouton restait alors visible et
     actif, le clic partait, et `addSame` sortait sur `!varianteId` — SANS un
     signal. Mesuré le 23/08 : une exécution sur trois ajoutait, les deux autres
     laissaient le panier intact, console propre, réseau propre.
     Le DOM, lui, porte la vérité : le bouton de taille pressé. On le lit, et on
     ne garde `varianteId` que comme repli. Un état dérivable ne se mémorise pas —
     il se relit à la source. */
  function varianteChoisie() {
    if (elSizes) {
      var actif = elSizes.querySelector('[aria-pressed="true"]');
      if (actif && actif.dataset.vid) return actif.dataset.vid;
      /* Aucune taille pressée après un re-rendu : on reprend la première
         disponible plutôt que de laisser un bouton qui ne fait rien. */
      var libre = elSizes.querySelector('button:not([disabled])');
      if (libre && libre.dataset.vid) { choisirTaille(libre.dataset.vid); return libre.dataset.vid; }
    }
    return varianteId;
  }

  function choisirTaille(id) {
    varianteId = id;
    Array.prototype.forEach.call(elSizes.children, function (b) {
      b.setAttribute('aria-pressed', String(b.dataset.vid === String(id)));
      if (b.dataset.vid === String(id) && elPill) elPill.textContent = b.textContent;
    });
  }

  function fillSizes(product, preferee) {
    if (!elSizes) return;
    elSizes.innerHTML = '';
    varianteId = null;
    (product.variants || []).forEach(function (v) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'onix-sj__taille';
      b.dataset.vid = String(v.id);
      b.textContent = v.title;
      b.setAttribute('aria-pressed', 'false');
      if (!v.available) {
        b.disabled = true;
        b.title = T.soldout;
      } else {
        b.addEventListener('click', function () { choisirTaille(v.id); });
      }
      elSizes.appendChild(b);
    });
    /* T2 — LA TAILLE SE REPORTE D'UN MAILLOT À L'AUTRE. Une taille est une
       propriété du CLIENT, pas du maillot : qui fait du XL fait du XL sur les
       quatre. Elle retombait sur la première disponible à chaque changement —
       mesuré le 19/08, XL redevenait S en silence, et le client ne s'en
       apercevait qu'à la réception.
       ⚠️ CE COMMENTAIRE PORTAIT UN CHIFFRE INVENTÉ, corrigé le 20/08. Il
         disait « 52 % des paniers "même modèle" ont deux tailles différentes »
         pour justifier de NE PAS reprendre la taille du panier au premier
         affichage. Mesuré depuis, sur 1 071 commandes depuis le 01/04 :
           243 cas où le même modèle est pris 2 fois ou plus
           243 avec la MÊME taille · 0 avec deux tailles différentes → 0 %
         Reproductible : grouper les lignes par produit, garder celles dont la
         quantité totale dépasse 1, compter les jeux de tailles distincts.
       ➜ Le premier affichage reprend donc la taille du panier, comme le
         report d'un maillot à l'autre. Aucun client observé n'a jamais pris le
         même maillot en deux tailles. */
    var dispo = (product.variants || []).filter(function (v) { return v.available; });
    var garde = preferee
      ? dispo.filter(function (v) { return v.title === preferee; })[0]
      : null;
    var cible = garde || dispo[0];
    if (cible) choisirTaille(cible.id);
  }

  /* Le libellé de la taille actuellement choisie — la clé du report. */
  function tailleChoisie() {
    if (!elSizes) return null;
    var b = elSizes.querySelector('[aria-pressed="true"]');
    return b ? b.textContent : null;
  }

  /* ── C4 : l'aperçu du dos se remplit à la saisie ──────────────────────
     Vide, il ne sert à rien — c'est vrai. Câblé sur les champs, il montre au
     client ce qu'il va recevoir ET rend « nom sous le numéro » évident sans
     lui coller une étiquette permanente. */
  /* F3 — LE BANDEAU NE MENT PLUS. Replié, il porte le flocage chargé au lieu
     de reproposer « Ajouter un nom… ». Trois états, un seul vrai à la fois. */
  function majBandeau() {
    if (!elToggle || !elBandTxt) return;
    var ouvert = elToggle.getAttribute('aria-expanded') === 'true';
    var vals = [];
    if (elName && elName.value.trim()) vals.push(elName.value.trim().toUpperCase());
    if (elNumber && elNumber.value.trim()) vals.push(elNumber.value.trim());
    if (elBelow && elBelow.value.trim()) vals.push(elBelow.value.trim().toUpperCase());
    var rempli = vals.length > 0 && !ouvert;
    elBandTxt.textContent = ouvert ? T.flocClose : (rempli ? T.flocLabel : T.flocOpen);
    if (elBandVal) {
      if (rempli) { elBandVal.textContent = vals.join(' · '); elBandVal.removeAttribute('hidden'); }
      else elBandVal.setAttribute('hidden', '');
    }
    elToggle.classList.toggle('is-rempli', rempli);
  }

  function majApercu() {
    majBandeau();
    if (!elDos) return;
    var n = (elName && elName.value.trim()) || '';
    var num = (elNumber && elNumber.value.trim()) || '';
    var b = (elBelow && elBelow.value.trim()) || '';
    if (elApNom) elApNom.textContent = n ? n.toUpperCase() : T.apNom.toUpperCase();
    if (elApNum) elApNum.textContent = num || T.apNum;
    if (elApSous) elApSous.textContent = b ? b.toUpperCase() : T.apSous.toUpperCase();
    elDos.classList.toggle('onix-sj__dos--plein', !!(n || num || b));
  }

  /* ── D4 : le bandeau ouvre et ferme le panneau ────────────────────────
     ⚠️ LE « + » DE LA CARTE S'ÉTEINT quand le panneau est ouvert. Sinon deux
       boutons d'ajout coexistent à 60 px l'un de l'autre, et celui du haut
       ajoute SANS le flocage qu'on vient de taper — le client ne s'en
       apercevrait qu'à la livraison. */
  function ouvrirPan(ouvert) {
    if (!elPan || !elToggle) return;
    if (ouvert) elPan.removeAttribute('hidden'); else elPan.setAttribute('hidden', '');
    elToggle.setAttribute('aria-expanded', String(ouvert));
    majBandeau();
    if (elPlus) elPlus.disabled = ouvert;
    if (!ouvert) return;

    /* ⚠️ IL FAUT AMENER LE PANNEAU DANS LA VUE. Mesuré : il s'ouvre 97 px sous
       le bas de la zone qui défile — le client tape le bandeau et RIEN ne
       semble se passer. La zone est bien défilante (133 px de marge), mais
       rien ne l'y conduit.
       ⚠️ `preventScroll` sur le focus : sans lui le navigateur y saute d'un
         coup, et on perd le lien visuel entre le bandeau tapé et le panneau
         qui s'ouvre. On fait le déplacement nous-mêmes, en douceur.
       ⚠️ `setTimeout` et pas `requestAnimationFrame` : la mise en page doit
         être calculée, et rAF ne s'exécute pas dans un onglet en arrière-plan
         — le panneau serait resté hors champ sans que rien ne le signale. */
    if (elName) { try { elName.focus({ preventScroll: true }); } catch (e) { try { elName.focus(); } catch (e2) {} } }

    /* ⚠️ `scrollIntoView` SUR LE BOUTON, et pas un scrollTop calculé à la main.
       Ma première version mesurait le panneau puis posait sc.scrollTop —
       et elle a échoué en silence : on ne peut pas savoir de l'extérieur si
       la zone a assez de marge ni où elle en est, et une mesure prise pendant
       l'animation d'ouverture du tiroir rend des valeurs figées.
       Le navigateur, lui, sait : il trouve le bon conteneur et le bon décalage.
       `block: 'nearest'` = il ne bouge QUE si c'est nécessaire.
       ⚠️ 60 ms, pas 0 : le panneau vient d'être démasqué, la mise en page
         n'est pas encore recalculée au tick suivant. */
    setTimeout(function () {
      var cible = elAdd || elPan;
      if (!cible || !cible.scrollIntoView) return;
      try { cible.scrollIntoView({ block: 'nearest', behavior: 'smooth' }); }
      catch (e) { cible.scrollIntoView(false); }
    }, 60);
  }

  /* ── ajout au panier (chemin 1) ── */
  /* ─── LE BLOC SORT, IL NE DISPARAÎT PAS ───────────────────────────────
     Avant : 182 px de contenu s'évaporaient en une frame et tout ce qui suit
     remontait d'un coup. Le bloc portait `transition: all`, qui n'anime rien
     ici — ce qui le fait partir est un changement de `display`, et `display`
     ne s'interpole pas. Ses mots, le 23/08 : « un truc archi fluide qui spawn
     pas d'un coup ».

     ⚠️ ON FIGE LA HAUTEUR AVANT DE L'ANIMER. `height: auto` ne s'interpole pas
     davantage que `display` : il faut une valeur de départ mesurée. D'où les
     deux temps — on pose la hauteur réelle, on force un reflow, puis on part
     vers 0. Sans le reflow, le navigateur regroupe les deux écritures et
     l'élément saute quand même.

     ⚠️ ET LE REPLI COMMENCE AU CLIC, pas à la réponse du serveur. C'est ce qui
     rend le geste instantané : les 320 ms d'animation couvrent l'aller-retour
     réseau au lieu de s'y ajouter. Quand le tiroir se rend, la place est déjà
     faite — la nouvelle ligne se déplie dans un espace qui ne bouge plus. */
  /* ⛔ TOUTE ANIMATION DE SORTIE DOIT SAVOIR REVENIR.
     `replierBloc()` pose `height: 0`, `overflow: hidden` et la classe
     `est-sortant` en style INLINE. Le bloc n'est pas recréé par le rendu du
     tiroir (il vit dans le Liquid, hors de drawerBody) : ces styles LUI
     SURVIVENT. Résultat mesuré le 23/08, et c'est LUI qui l'a vu : après
     quelques ajouts/suppressions, un panier à un maillot ne proposait plus
     l'offre — le bloc était pourtant bien dé-`hidden`, simplement haut de 0 px.
     Une régression que j'ai introduite en rendant la sortie fluide.
     ➜ Un état posé à la main se retire à la main. On nettoie AVANT chaque
     réaffichage, jamais « quand ça se trouvera ». */
  function reouvrirBloc() {
    if (!root) return;
    delete root.dataset.sjSortant;
    root.classList.remove('est-sortant');
    root.style.height = '';
    root.style.overflow = '';
    debutRepli = 0;
  }

  /* ─── LA LIGNE ARRIVE AVANT LE SERVEUR ────────────────────────────────
     Mesuré le 23/08 : 1,9 s entre le clic sur « + » et le tiroir à jour, dont
     ~1,6 s de VIDE — le bloc s'était replié, et rien n'avait encore pris sa
     place. Ses mots : « y'a toujours ce moment d'hésitation qui est beaucoup
     trop lent, mets un chargement au moins qu'on sache qu'il faut attendre ».

     Un spinner aurait dit « attends » ; une ligne fantôme dit « ton maillot
     arrive » — c'est la même attente, mais le client sait CE QU'IL ATTEND, et
     il le voit à l'endroit exact où le résultat apparaîtra. On reprend la photo
     et le titre déjà chargés dans la carte : ce n'est pas une invention, c'est
     le maillot qu'il vient de choisir.

     ⚠️ Elle porte `data-sj-fantome` et JAMAIS `data-cart-item-key` : le rendu du
     tiroir compare ces clés pour animer les lignes neuves, et une clé inventée
     ici ferait passer la vraie ligne pour déjà présente — elle n'entrerait pas
     en scène. Le fantôme est retiré par le rendu suivant, qui réécrit tout le
     corps ; le filet à 8 s ne sert que si ce rendu n'arrive jamais. */
  function poserLigneFantome() {
    /* ⚠️ PAS DANS `drawerBody`, ET C'EST TOUT LE SUJET. Mesuré : posé là, le
       fantôme vivait **100 ms** — le tiroir réécrit son corps entier
       (`innerHTML = …`) dès le premier rafraîchissement, et emporte tout ce
       qu'on y avait glissé. On le pose donc à CÔTÉ du bloc « 2e maillot », qui
       vit dans le Liquid, hors du corps, et survit aux rendus (c'est la même
       propriété qui avait causé la régression du bloc replié à jamais).
       Il est retiré explicitement quand le panier est rendu. */
    if (!root || !root.parentNode) return;
    if (root.parentNode.querySelector('[data-sj-fantome]')) return;
    var img = root.querySelector('[data-sj-img]');
    var titre = root.querySelector('[data-sj-club]');
    var el = document.createElement('div');
    el.setAttribute('data-sj-fantome', '');
    el.className = 'onix-sj-fantome';
    el.setAttribute('aria-live', 'polite');
    el.innerHTML =
      '<span class="onix-sj-fantome__media">' +
        (img && img.src ? '<img src="' + img.src + '" alt="">' : '') +
      '</span>' +
      '<span class="onix-sj-fantome__corps">' +
        '<span class="onix-sj-fantome__titre">' + ((titre && titre.textContent) || '') + '</span>' +
        '<span class="onix-sj-fantome__barre"></span>' +
      '</span>';
    root.parentNode.insertBefore(el, root.nextSibling);
    /* Deux chemins de retrait, parce qu'un seul ne suffit jamais : le rendu du
       panier (cas normal) et un filet à 8 s si ce rendu n'arrive jamais. */
    /* ⚠️ PAS SUR `cart:refresh` — mesuré : il part dans les 100 ms qui suivent le
       clic, bien AVANT que le panier soit rendu, et il emportait le fantôme
       aussitôt posé. Mon premier diagnostic accusait le tiroir de réécrire son
       corps ; c'était mon propre retrait qui était trop pressé.
       Seul `onix:cart-rendered` veut dire « le panier est à l'écran ».
       ⚠️ Et une DURÉE MINIMALE : un fantôme qui apparaît et disparaît en
       200 ms est un clignotement, plus gênant que l'attente qu'il couvre. */
    /* ⚠️ PAS DE DURÉE MINIMALE QUAND LE VRAI EST ARRIVÉ. J'en avais posé une de
       550 ms pour éviter un clignotement : elle maintenait le fantôme À CÔTÉ de
       la vraie ligne déjà affichée — deux fois le même maillot à l'écran, puis
       une disparition sèche. Ses mots : « si l'écran de chargement il disparaît
       ça pue la merde ». Un doublon est pire que le clignotement qu'on évitait.
       ➜ Le fantôme part DÈS que le panier est rendu, et il part en SORTANT :
       il se replie et s'efface comme le bloc au-dessus, même courbe, au lieu
       d'être arraché du DOM. Le minimum ne joue plus que si le rendu n'est pas
       encore arrivé — pour ne pas clignoter sur un panier qui répond vite. */
    var POSE = Date.now();
    var oter = function (immediat) {
      if (el.dataset.sort === '1') return;
      var reste = immediat ? 0 : 260 - (Date.now() - POSE);
      if (reste > 16) return void setTimeout(function () { oter(immediat); }, reste);
      el.dataset.sort = '1';
      var h = el.getBoundingClientRect().height;
      el.style.height = h + 'px';
      el.style.overflow = 'hidden';
      void el.offsetHeight;
      el.classList.add('est-sortant');
      el.style.height = '0px';
      setTimeout(function () { if (el.parentNode) el.parentNode.removeChild(el); }, 300);
    };
    /* ⛔ PAS D'ÉVÉNEMENT INVENTÉ. J'écoutais `onix:cart-rendered` : **il n'existe
       pas**. Le tiroir n'émet que `cart:refresh`, et 5 fois. Mon écouteur n'a
       donc jamais rien reçu, le fantôme restait jusqu'au filet de 8 s — À CÔTÉ
       de la vraie ligne. Mesuré : 50 frames de doublon sur 5 s.
       ➜ On observe le FAIT : le corps du tiroir réécrit avec la ligne à jour.
       `cart:refresh` est une intention (elle part en 100 ms, avant le rendu) ;
       le remplacement du corps est le fait. Un nettoyage se branche sur le fait.
       L'observateur se débranche au premier déclenchement utile — sans ça il se
       rappellerait sur sa propre écriture. */
    var corps = document.querySelector('.onix-cart-drawer__body');
    if (corps && window.MutationObserver) {
      var guet = new MutationObserver(function () {
        if (Date.now() - POSE < 200) return;      /* le rendu d'avant, pas le nôtre */
        guet.disconnect();
        oter(true);
      });
      guet.observe(corps, { childList: true });
      setTimeout(function () { try { guet.disconnect(); } catch (e) {} }, 8000);
    }
    setTimeout(function () { oter(true); }, 8000);
  }

  function replierBloc() {
    if (!root || root.dataset.sjSortant === '1') return;
    root.dataset.sjSortant = '1';
    var h = root.getBoundingClientRect().height;
    if (h < 2) return;
    root.style.height = h + 'px';
    root.style.overflow = 'hidden';
    void root.offsetHeight;                    /* reflow : sans lui, pas d'animation */
    root.classList.add('est-sortant');
    root.style.height = '0px';
    debutRepli = Date.now();
  }

  var debutRepli = 0;
  var DUREE_REPLI = 340;                       /* doit rester égal au CSS */

  /* Le rendu attend que la PLACE soit faite, jamais l'inverse. Si le réseau a
     mis plus longtemps que le repli, on rend tout de suite — on n'ajoute
     jamais d'attente à une attente. */
  function quandLaPlaceEstFaite() {
    var reste = debutRepli ? DUREE_REPLI - (Date.now() - debutRepli) : 0;
    return reste > 16
      ? new Promise(function (ok) { setTimeout(ok, reste); })
      : Promise.resolve();
  }

  function addSame() {
    if (busy) return;
    var vid = varianteChoisie();
    if (!vid) {
      /* ⛔ PLUS JAMAIS DE RETOUR MUET SUR UNE GARDE. Un clic sans effet est
         indiscernable d'un clic perdu : c'est ce qui a coûté deux diagnostics
         faux le 23/08. Si on ne peut pas ajouter, on le DIT. */
      setError(true);
      return;
    }
    varianteId = vid;
    busy = true;
    replierBloc();
    poserLigneFantome();
    setError(false);
    if (elAdd) elAdd.disabled = true;
    if (elPlus) elPlus.disabled = true;

    /* ⚠️ TROIS propriétés, pas deux. Le quick-add en propose trois — Nom,
       Numéro, « Nom sous le numéro » — et ce bloc n'en portait que deux : un
       client passant par l'offre ne POUVAIT PAS mettre la ligne du dessous.
       Les clés sont celles du quick-add au caractère près, sinon la même
       option apparaît deux fois dans la commande sous deux noms. */
    var properties = {};
    var n = (elName && elName.value.trim()) || '';
    var num = (elNumber && elNumber.value.trim()) || '';
    var below = (elBelow && elBelow.value.trim()) || '';
    if (n) properties['Nom'] = n;
    if (num) properties['Numéro'] = num;
    if (below) properties['Nom sous le numéro'] = below;

    var payload = { items: [{ id: Number(vid), quantity: 1 }] };
    if (Object.keys(properties).length) payload.items[0].properties = properties;

    /* ─── LE CODE DE PALIER NE SE POSE PAS D'ICI, ET C'EST LA LEÇON ──────
       `cart-drawer-promo-suggest.js` est le PROPRIÉTAIRE des codes de palier :
       son `setSessionDiscount()` efface la session (`discount=`) avant de
       reposer la liste, parce que Shopify garde la plus grosse remise sur
       collision et bloquerait sinon les rétrogradations.

       Poser onix3 depuis ici mettait deux modules sur la même session. Mesuré
       le 23/08 : le serveur seul enchaîne parfaitement (ajout + /discount en
       parallèle → 2 art / 42,49 € / onix3, vérifié hors tiroir), mais avec le
       tiroir ouvert l'article disparaissait — l'effacement de l'un tombait sur
       l'écriture de l'autre. Aucune erreur, aucune trace : juste un panier qui
       reste à 1.

       ➜ Un code de session a UN propriétaire. On ajoute, on rafraîchit, et
       promo-suggest applique le palier qu'il gère déjà. C'est une requête de
       plus, pas un rendu de plus : le rendu reste unique, en fin de chaîne. */
    fetch(rootPath + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload),
    })
      .then(function (r) { if (!r.ok) throw new Error('add ' + r.status); return r.json(); })
      .then(function () { return fetch(rootPath + 'cart.js').then(function (r) { return r.json(); }); })
      /* Le palier s'applique AVANT le rendu, par son propriétaire. Le client ne
         voit donc jamais le prix plein : une seule peinture, déjà remisée. */
      .then(function (cart) {
        if (typeof window.__onixAppliquerPalier !== 'function') return cart;
        return window.__onixAppliquerPalier(cart)
          .then(function (pose) {
            if (!pose) return cart;
            return fetch(rootPath + 'cart.js').then(function (r) { return r.json(); });
          })
          .catch(function () { return cart; });
      })
      .then(function (cart) {
        return quandLaPlaceEstFaite().then(function () { return cart; });
      })
      .then(function (cart) {
        /* ⚠️ ON PASSE PAR __onixRefreshCart, PAS PAR UN ÉVÉNEMENT.
           Le tiroir IGNORE volontairement les `cart:refresh` qui portent un
           `detail.cart` : c'est ainsi qu'il reconnaît ses propres dispatches
           et évite de se re-rendre en boucle. Notre événement, qui en portait
           un, tombait donc dans ce garde — le maillot était bien ajouté au
           panier mais N'APPARAISSAIT PAS dans le tiroir avant un rechargement
           de la page. C'est exactement ce que fait le quick-add, qui lui
           n'avait jamais eu le problème.
           Repli sur l'événement NU (sans detail) si la fonction n'est pas là :
           un événement sans panier n'est pas filtré. */
        try {
          if (window.__onixRefreshCart) window.__onixRefreshCart();
          else document.dispatchEvent(new CustomEvent('cart:refresh'));
        } catch (e) {}
        if (elName) elName.value = '';
        if (elNumber) elNumber.value = '';
        if (elBelow) elBelow.value = '';
        majApercu();
        ouvrirPan(false);
      })
      .catch(function () { setError(true); })
      .then(function () {
        busy = false;
        if (elAdd) elAdd.disabled = false;
        if (elPlus) elPlus.disabled = !!(elToggle && elToggle.getAttribute('aria-expanded') === 'true');
      });
  }

  /* ── LA RANGÉE — construction ─────────────────────────────────────────
     Elle remplace le lien « Choisir un autre maillot ». Elle ne montre pas un
     chemin, elle montre des maillots : le tap PREND celui qu'on tape, sur
     place, sans popup. La tuile reste la seule sortie vers la grille. */
  var ALTS_MONTREES = 3;   /* R1 — la rangée n'était pas pleine à deux */
  var MAILLOTS_GRILLE = 12;   /* 12 sur 4 colonnes = 3 rangées PLEINES.
     ⚠️ Le nombre de COLONNES n'est pas ici : il est en CSS
     (cart-drawer.css, `.onix-sj-grid__items`, `repeat(4, 1fr)`). Une
     constante `COLONNES = 4` a vécu ici sans jamais être lue — deux
     sources pour une seule décision, dont une inerte. Si le nombre de
     colonnes change, c'est le CSS qu'on touche, et ce nombre-ci doit
     rester un multiple pour garder des rangées pleines : sa consigne du
     19/08, « il faut avoir des rangées qui sont paires donc logiquement 4 ». */

  function litListe() {
    /* MÊME source et MÊME ordre que la grille : le contrôleur en propose
       MAILLOTS_GRILLE, le maillot du panier exclu. Toute divergence rendrait
       le compte de la tuile « +N » faux. */
    var pool = [];
    try {
      var raw = document.getElementById('onix-cart-bestsellers');
      if (raw) pool = JSON.parse(raw.textContent) || [];
    } catch (e) {}
    /* DIX MAILLOTS, quatre par rangée — sa consigne du 19/08.
       ⚠️ J'avais coupé la liste à NEUF pour tomber juste sur trois colonnes.
         C'était résoudre le mauvais problème : il parlait de la DISPOSITION,
         pas du nombre de maillots. Le catalogue proposé ne se réduit pas pour
         arranger une grille — c'est la grille qui s'adapte.
       Le compte de la tuile « +N » se déduit de cette même liste, donc les
       deux restent d'accord quoi qu'il arrive. */
    return pool
      .filter(function (p) { return p.handle !== currentHandle; })
      .slice(0, MAILLOTS_GRILLE);
  }

  function ordreRangee() {
    /* A2 — LE CHOISI PASSE EN TÊTE, celui du panier glisse à sa suite.
       Le maillot du panier n'est PAS une alternative : il ne se déduit donc
       jamais du compte de la tuile. */
    var base = _liste.slice(0, ALTS_MONTREES);
    var panier = { handle: currentHandle, image: null, panier: true };
    if (!_choisi || _choisi === currentHandle) return [panier].concat(base);
    var choisi = _liste.filter(function (p) { return p.handle === _choisi; })[0];
    if (!choisi) return [panier].concat(base);
    var reste = base.filter(function (p) { return p.handle !== _choisi; });
    return [choisi, panier].concat(reste).slice(0, ALTS_MONTREES + 1);
  }

  function renderRangee() {
    if (!elRangee) return;
    if (!_liste.length) { elRangee.setAttribute('hidden', ''); return; }
    var items = ordreRangee();
    var html = '<span class="onix-sj__ou">' + escapeHtml(T.ou) + '</span>';
    var alts = 0;
    var aEtiquette = false;
    items.forEach(function (p) {
      var estPanier = !!p.panier;
      if (!estPanier) alts++;
      var actif = (p.handle === (_choisi || currentHandle));
      var img = estPanier ? _imgPanier : (p.featured_image || '');
      /* l'étiquette dit POURQUOI ce maillot est là — ce que le cercle de
         sélection ne dit pas. Elle ne s'affiche que s'il n'est plus l'actif. */
      var etq = (estPanier && !actif);
      if (etq) aEtiquette = true;
      /* le maillot du panier n'est pas dans _liste : on lit ses tags sur le
         produit chargé, seule source qui les porte pour lui. */
      var fiche = estPanier ? _fichePanier : p;
      html += '<button type="button" class="onix-sj__vig" data-sj-vig="' + escapeHtml(p.handle)
            + '" aria-pressed="' + (actif ? 'true' : 'false') + '">'
            /* ⚠️ PAS DE BADGE ★★ SUR LES VIGNETTES — sa consigne du 20/08.
               La 1re vignette est le maillot que le client VIENT d'ajouter :
               il sait déjà qu'il est 2 étoiles, l'étoile ne lui apprend rien
               et « ça gêne ». Le badge reste sur la CARTE de l'offre, où il
               parle d'un maillot qu'on lui propose — pas d'un qu'il a choisi.
               ⚠️ `fiche` reste calculé au-dessus : il sert au titre. */
            /* ⚠️ PAS DE `loading="lazy"`. La rangée est construite pendant que
               #onix-second-jersey est encore `hidden` : une image paresseuse
               posée dans un sous-arbre masqué ne se charge JAMAIS, et les
               quatre vignettes sortaient vides. Même piège que la photo de la
               carte, corrigé plus tôt aujourd'hui — et il ne coûte rien ici,
               puisque le `src` n'est écrit que si l'offre s'affiche. */
            + '<img src="' + escapeHtml(vignette(img)) + '" alt="" decoding="async">'
            + (etq ? '<span class="onix-sj__vig-etq">' + escapeHtml(T.auPanier) + '</span>' : '')
            + '</button>';
    });
    var reste = _liste.length - alts;
    html += reste > 0
      ? '<button type="button" class="onix-sj__tuile" data-sj-tuile aria-label="'
        + escapeHtml(T.other) + '">+' + reste + '</button>'
      : '';
    elRangee.innerHTML = html;
    elRangee.classList.toggle('onix-sj__rangee--etq', aEtiquette);
    elRangee.removeAttribute('hidden');
  }

  /* ── LE BADGE « 2 ÉTOILES » ───────────────────────────────────────────
     Vrai si le produit porte le TAG posé en back-office. Le tag fait foi et
     pas le titre : sur les trois maillots deux étoiles du catalogue, deux le
     disent dans leur nom et le troisième non — se fier au titre en aurait
     laissé un sur le carreau. Le repli sur le titre ne sert qu'aux fiches
     taguées plus tard.
     ⚠️ La comparaison ignore accents, casse et tirets : « 2 Étoiles »,
       « 2-etoiles » et « 2 etoiles » désignent la même chose, et personne ne
       retape un tag au caractère près six mois plus tard. */
  function normalise(x) {
    return String(x || '')
      .normalize('NFD').replace(/[\u0300-\u036f]/g, '')
      .toLowerCase().replace(/[^a-z0-9]+/g, ' ').trim();
  }
  function estDeuxEtoiles(p) {
    if (!p) return false;
    if ((p.tags || []).map(normalise).indexOf('2 etoiles') !== -1) return true;
    return normalise(p.title).indexOf('2 etoiles') !== -1;
  }
  /* L'étoile du club. La FORME vient de son visuel, découpée au pixel près
     par scripts/extraire-etoile.py et posée en masque CSS ; la COULEUR vient
     du badge. Rien n'est redessiné ici — une version tracée à la main a été
     jetée le 19/08, elle sortait écrasée. */
  var ETOILE_SVG = '<span class="onix-etoile" aria-hidden="true"></span>';



  function badgeEtoiles(avecTexte) {
    return '<span class="onix-etoiles' + (avecTexte ? ' onix-etoiles--texte' : '') + '" aria-hidden="true">'
         + '<span class="onix-etoiles__astres">' + ETOILE_SVG + ETOILE_SVG + '</span>'
         + (avecTexte ? '<span>' + escapeHtml(T.deuxEtoiles) + '</span>' : '')
         + '</span>';
  }

  /* Une vignette de 34 px n'a aucun besoin d'un fichier de 300. */
  function vignette(src) {
    if (!src) return '';
    return src.indexOf('width=') === -1
      ? src + (src.indexOf('?') === -1 ? '?' : '&') + 'width=120'
      : src.replace(/width=\d+/, 'width=120');
  }

  function escapeHtml(x) {
    return String(x).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  /* Taper une vignette : on charge ce produit et on repeint la carte. C'est
     EXACTEMENT le chemin du premier affichage — aucune mécanique nouvelle. */
  function choisir(handle) {
    if (busy || handle === _choisi) return;
    busy = true;
    setError(false);
    /* lu AVANT le rechargement : fillSizes va vider le rang. */
    var garder = tailleChoisie();
    fetch(rootPath + 'products/' + handle + '.js')
      .then(function (r) { if (!r.ok) throw new Error('produit ' + r.status); return r.json(); })
      .then(function (product) {
        currentProduct = product;
        _choisi = handle;
        fillSizes(product, garder);   /* T2 — on reporte la taille */
        peindre(product, null);
        ouvrirPan(false);             /* F3 — replie, mais le bandeau le dira */
        renderRangee();
      })
      .catch(function () { setError(true); })
      .then(function () { busy = false; });
  }

  /* ── la grille « un autre maillot » ───────────────────────────────────
     Neuf maillots en 3 × 3, image et titre, rien d'autre. Un clic ferme la
     grille et charge le maillot DANS LA CARTE de l'offre — même chemin qu'un
     tap sur une vignette de la rangée. */
  var overlay = null;
  function closeGrid() {
    if (!overlay) return;
    overlay.remove();
    overlay = null;
    /* ⚠️ On ne touche plus au défilement du document : la feuille vit
       DANS le tiroir, qui gère déjà le sien. Le remettre à '' ici écrasait
       le `overflow: hidden` que le tiroir pose sur <html> quand il est
       ouvert — refermer la grille rendait la page défilable derrière. */
  }
  function openGrid() {
    if (overlay) return;
    /* ⚠️ LA MÊME LISTE QUE LA RANGÉE, pas une seconde lecture du vivier.
       Deux sources auraient fini par diverger, et le « +N » de la tuile serait
       devenu faux sans que rien ne le signale. */
    if (!_liste.length) return;

    /* Les 10 MEILLEURES VENTES, sans le maillot déjà au panier (choix Yacine
       2026-08-02, en écart assumé avec le PDF qui le voulait en 1re position) :
       reprendre le même modèle est déjà couvert par le chemin 1 juste au-dessus,
       le rappeler ici ferait doublon. */
    var list = _liste;

    overlay = document.createElement('div');
    overlay.className = 'onix-sj-grid';
    overlay.setAttribute('role', 'dialog');
    overlay.setAttribute('aria-modal', 'true');

    var panel = document.createElement('div');
    panel.className = 'onix-sj-grid__panel';

    /* la poignée : elle dit qu'on referme en tirant, et elle sert de bouton
       de fermeture — la feuille n'a plus de croix. */
    var poignee = document.createElement('button');
    poignee.type = 'button';
    poignee.className = 'onix-sj-grid__poignee';
    poignee.setAttribute('aria-label', T.close);
    poignee.addEventListener('click', closeGrid);

    var head = document.createElement('div');
    head.className = 'onix-sj-grid__head';
    var h = document.createElement('p');
    h.className = 'onix-sj-grid__title';
    h.textContent = T.otherTitle;
    head.appendChild(h);

    var grid = document.createElement('div');
    grid.className = 'onix-sj-grid__items';
    list.forEach(function (p) {
      var card = document.createElement('button');
      card.type = 'button';
      card.className = 'onix-sj-card';
      /* ⚠️ LE CLIC CHARGE LE MAILLOT DANS LA CARTE DE L'OFFRE — il n'ouvre
         PLUS le quick-add. Le quick-add était le bon chemin tant que l'offre
         était un formulaire sans photo ni titre : il fallait bien un écran
         pour choisir la taille et le flocage. Depuis que l'offre EST une
         carte, avec ses tailles en rang, son flocage et son aperçu du dos,
         ouvrir un second écran par-dessus fait faire deux fois le même
         travail — et sur un écran qui ne connaît ni le maillot en cours ni
         le flocage déjà saisi.
         La grille redevient ce qu'elle doit être : la rangée de vignettes en
         plus grand. Elle choisit, elle ne configure pas. */
      if (estDeuxEtoiles(p)) {
        var b = document.createElement('span');
        b.className = 'onix-etoiles';
        b.setAttribute('aria-hidden', 'true');
        b.innerHTML = '<span class="onix-etoiles__astres">' + ETOILE_SVG + ETOILE_SVG + '</span>';
        card.appendChild(b);
      }
      if (p.featured_image) {
        var img = document.createElement('img');
        img.className = 'onix-sj-card__img';
        img.src = p.featured_image;
        img.alt = p.title || '';
        /* ⚠️ PAS DE `lazy`. La grille n'est construite QU'AU MOMENT où on
           l'ouvre, et ses douze vignettes sont visibles d'un coup : il n'y a
           rien à différer. « lazy » ne faisait que retarder la dernière
           rangée, qui apparaissait après les autres. Quatrième fois
           aujourd'hui que cet attribut coûte plus qu'il ne rapporte dans ce
           tiroir — carte, vignettes de la rangée, et ici. */
        img.decoding = 'async';
        card.appendChild(img);
      }
      var name = document.createElement('span');
      name.className = 'onix-sj-card__name';
      /* ⚠️ ON GARDAIT LA SEULE ÉQUIPE, et ça jetait le modèle.
           « Paris Saint-Germain – Maillot Domicile 2 Étoiles 2026/27 – Bleu… »
           s'affichait « Paris Saint-Germain » : le client ne pouvait pas voir
           qu'il s'agit de la version DEUX ÉTOILES, alors que la boutique vend
           aussi le même maillot sans. Et deux fiches PSG voisines devenaient
           indiscernables.
         On applique donc la MÊME règle que la carte du panier : on retire le
         DERNIER segment (la couleur, convention du catalogue) et on garde le
         reste. Découpeur partagé, exposé par cart-drawer.js — en recopier la
         logique en ferait une quatrième source. */
      var d = window.__onixTitreEnDeux
        ? window.__onixTitreEnDeux(p.title || '')
        : { club: String(p.title || ''), reste: '' };
      name.textContent = d.reste ? d.club + ' ' + d.reste : d.club;
      card.appendChild(name);
      /* Pas de prix sur les cartes : il vaut 17,50 € sur les dix, donc il
         n'aide pas à choisir et il coûte une ligne par carte. Il reste sur la
         carte de l'offre, et le quick-add qui s'ouvre ensuite le porte aussi
         (data-qa-price-cents, posé plus haut). */
      card.addEventListener('click', function () {
        closeGrid();
        choisir(p.handle);
      });
      grid.appendChild(card);
    });

    panel.appendChild(poignee);
    panel.appendChild(head);
    panel.appendChild(grid);
    overlay.appendChild(panel);
    overlay.addEventListener('click', function (e) { if (e.target === overlay) closeGrid(); });
    document.addEventListener('keydown', function esc(e) {
      if (e.key === 'Escape') { closeGrid(); document.removeEventListener('keydown', esc); }
    });
    /* ⚠️ DANS LE PANNEAU DU TIROIR, PAS DANS LE BODY. C'est ce qui fait que la
       feuille monte du bas DU TIROIR et s'y découpe : le panneau est déjà
       `position: absolute`, `overflow: hidden` et arrondi. Posée sur le body
       elle recouvrait la page entière — et le tiroir avec.
       Repli sur le body si la structure change : mieux vaut une feuille au
       mauvais endroit qu'un sélecteur qui ne s'ouvre pas. */
    var hote = document.querySelector('.onix-cart-drawer__panel') || document.body;
    hote.appendChild(overlay);
  }

  /* ── affichage : uniquement quand le panier a EXACTEMENT 1 article ── */
  function refresh(cart) {
    var count = cart && typeof cart.item_count === 'number' ? cart.item_count : null;
    if (count !== 1) { root.setAttribute('hidden', ''); return; }
    /* ⛔ ON MÉMORISE LE SOUS-TOTAL ICI — 30/08, 07h25.
         `peindre()` reçoit `item = null` dès que le client choisit un AUTRE
         produit que celui du panier (l.940) — c'est-à-dire exactement le cas de
         la veste, le seul qui posait problème. Mon calcul retombait donc sur la
         constante 17,50 €, et je l'ai annoncé « corrigé » après avoir vérifié la
         formule sur papier et le cas maillot, qui marchait déjà avant.
         Le sous-total ne dépend pas du produit PROPOSÉ : il ne dépend que du
         panier. On le prend là où il est certain — ici — et `peindre` s'en sert
         quel que soit son second argument. */
    _sousTotalPanier = (typeof cart.items_subtotal_price === 'number')
      ? cart.items_subtotal_price
      : (cart.items && cart.items[0] ? cart.items[0].final_line_price : 0);

    var item = (cart.items || [])[0];
    if (!item || !item.handle) { root.setAttribute('hidden', ''); return; }
    if (item.quantity !== 1) { root.setAttribute('hidden', ''); return; }

    /* ⛔ L'OFFRE NE VAUT QUE POUR UN MAILLOT — 24/08, trouvé par LUI :
       « les vestes Brésil, quand j'en ajoute une au panier ça en propose une 2e
       pour 17,50 € alors que c'est pas un maillot ».
       Le 17,50 € n'est pas un prix, c'est un CALCUL : 4998 − 749 − 2499, soit ce
       que coûte le second maillot une fois le palier appliqué sur DEUX articles à
       24,99 €. Sur une veste à 59,99 €, le montant annoncé est simplement faux —
       et la carte promettait un prix que le panier n'aurait jamais tenu.
       Le bloc ne se contentait de compter les articles : un article au panier,
       une offre. Il ne regardait pas CE QU'IL Y AVAIT dedans.

       ⚠️ On compare au PRIX DE RÉFÉRENCE de l'offre (`SECOND_CENTS` en dérive),
       pas à une liste de tags ni à une catégorie : le prix est la seule donnée
       que /cart.js porte toujours, sur tous les produits, sans appel
       supplémentaire — et c'est exactement la grandeur sur laquelle le calcul
       repose. Un tag oublié sur une gamme future rouvrirait le défaut ;
       un prix qui ne correspond pas ferme l'offre par construction. */
    var prixUnite = Math.round((item.original_price != null ? item.original_price : item.price) || 0);
    if (!estAuPrixMaillot(prixUnite)) { root.setAttribute('hidden', ''); return; }

    if (item.handle === currentHandle && currentProduct) {
      /* ⚠️ ON NE REPEINT PAS DEPUIS LA LIGNE DE PANIER si le client a changé de
         maillot dans la rangée : ce serait remettre le maillot du panier dans
         la carte au premier rafraîchissement venu, en effaçant son choix. */
      peindre(currentProduct, (_choisi && _choisi !== currentHandle) ? null : item);
      renderRangee();
      reouvrirBloc();
      root.removeAttribute('hidden');
      return;
    }
    currentHandle = item.handle;
    _choisi = item.handle;
    _liste = litListe();
    fetch(rootPath + 'products/' + item.handle + '.js')
      .then(function (r) { return r.json(); })
      .then(function (product) {
        currentProduct = product;
        /* c'est ICI, et seulement ici, qu'on tient le produit du PANIER :
           `choisir()` remplace ensuite currentProduct par un autre. */
        _imgPanier = (item && item.image) || product.featured_image || '';
        _fichePanier = { tags: product.tags || [], title: product.title || '' };
        /* ⚠️ LA TAILLE DU PANIER, PAS LA PREMIÈRE DISPONIBLE — trouvé le
             20/08 en testant le site EN LIGNE comme un client. Le client
             venait de choisir « M » sur la fiche produit, et l'offre lui
             proposait « S » : `fillSizes(product)` sans préférence retombe sur
             la première taille en stock.
           ⚠️ C'est LE cas le plus fréquent de l'offre, puisqu'elle propose par
             défaut le maillot déjà au panier. Proposer une autre taille que
             celle qu'il vient de choisir, c'est lui demander de la re-choisir
             — ou pire, la lui faire manquer.
           ⚠️ `variant_title` peut valoir « Default Title » sur un produit sans
             option : `fillSizes` retombe alors sur la première disponible,
             comme avant. */
        fillSizes(product, item && item.variant_title);
        peindre(product, item);
        ouvrirPan(false);
        renderRangee();
        reouvrirBloc();
      root.removeAttribute('hidden');
      })
      .catch(function () { root.setAttribute('hidden', ''); });
  }

  /* ── la carte : photo, titre sur deux lignes, prix ────────────────────
     C'est LE maillot du panier, pas un autre — le fetch ci-dessus part de
     item.handle. Jusqu'ici rien ne le montrait : ni photo, ni titre. */
  function peindre(product, item) {
    if (elImg) {
      /* l'image de la LIGNE de panier d'abord : elle porte déjà la variante,
         et elle est en cache puisque la carte du dessus l'affiche. */
      var src = (item && item.image) || product.featured_image || '';
      /* ⚠️ REDIMENSIONNER. /cart.js rend l'URL BRUTE du fichier : mesuré, 1125 px
         de large téléchargés pour une vignette de 67. La carte du panier, elle,
         passe déjà par `| image_url: width: 320` côté Liquid. 200 px couvre le
         double densité (67 × 2 = 134) avec de la marge. */
      if (src && src.indexOf('width=') === -1) {
        src += (src.indexOf('?') === -1 ? '?' : '&') + 'width=200';
      }
      if (src && elImg.getAttribute('src') !== src) elImg.setAttribute('src', src);
      elImg.alt = '';
    }
    /* ⚠️ LE BADGE LONG NE TIENT PAS SUR LA PHOTO : 31 px de pastille sur
       62 px de large, il débordait. Sur la carte de l'offre il va donc SUR LA
       LIGNE DU TITRE, en flux normal — c'est le seul endroit du bloc qui ait
       la largeur pour écrire les mots, et c'est là que l'œil lit ce qu'est le
       maillot. La photo garde la version courte ailleurs (rangée, grille). */
    var anc = root.querySelector('.onix-sj__haut .onix-etoiles');
    if (anc) anc.remove();
    var titre = product.title || (item && item.product_title) || '';
    /* ⚠️ Découpeur PARTAGÉ, exposé par cart-drawer.js. En recopier la logique
       en ferait une 3e source après ce fichier et product-card-title.liquid. */
    var d = (window.__onixTitreEnDeux ? window.__onixTitreEnDeux(titre) : { club: titre, reste: '' });
    if (elClub) elClub.textContent = d.club;
    if (estDeuxEtoiles(product) && elClub && elClub.parentNode) {
      elClub.insertAdjacentHTML('afterend', badgeEtoiles(true));
    }
    if (elSous) elSous.textContent = d.reste;

    /* ⛔ LE PRIX SUIT LE PRODUIT PROPOSÉ — 30/08, 07h05. C'EST LUI QUI L'A VU :
         « dans le panier ça propose la veste en 2e maillot, je suis pas contre
           mais du coup c'est pas pour 17,50 ».

       CE QUI SE PASSAIT : `SECOND_CENTS` est une CONSTANTE (1750), calculée dans
       le Liquid pour un maillot à 24,99 €. Le bloc l'affichait quel que soit le
       produit proposé — y compris une veste à 59,99 €.

       CALCULÉ, pas estimé (palier 2 articles = 15 %) :
         2e article MAILLOT  panier 49,98 → 42,48 · le 2e coûte 17,49 · affiché 17,50 ✅
         2e article VESTE    panier 84,98 → 72,23 · le 2e coûte 47,24 · affiché 17,50 ⛔
       Soit **29,74 € d'écart** entre le prix annoncé et le prix payé. Le client
       clique sur « 17,50 € » et découvre 47,24 € sur son total. Ce n'est pas un
       défaut d'affichage, c'est un prix faux — et il se voit au paiement.

       ⚠️ LA REMISE PORTE SUR LE PANIER ENTIER, PAS SUR LE 2e ARTICLE. C'est ce
         qui rend la formule non intuitive : « le 2e à 17,50 € » est en réalité
         « 24,99 € moins les 7,49 € de remise obtenue sur les deux ». Donc le
         prix du 2e article dépend AUSSI de ce qui est déjà au panier.
         prix affiché = prix du produit − (panier + produit) × taux du palier

       ⚠️ REPLI SUR LA CONSTANTE si on ne sait pas calculer (taux inconnu, panier
         illisible) : mieux vaut l'ancien affichage, faux dans un cas, qu'un prix
         vide ou un NaN sur tous. */
    var plein = (product && product.price) || 0;
    var affiche = SECOND_CENTS;
    try {
      var taux = tauxPalierCourant();
      /* ⚠️ PAS `item` : il vaut null dès qu'un autre produit est choisi. */
      var dejaAuPanier = _sousTotalPanier;
      if (taux > 0 && plein > 0 && dejaAuPanier > 0) {
        var calcule = Math.round(plein - (dejaAuPanier + plein) * taux);
        if (calcule > 0 && calcule <= plein) affiche = calcule;
      }
    } catch (e) { /* on garde SECOND_CENTS plutôt qu'un prix vide */ }

    /* ⛔ LE BADGE SUIT LE PRODUIT — 30/08. « 2ᵉ MAILLOT » sur une veste était
       faux, et c'est le premier mot que l'œil lit sur ce bloc.
       ⚠️ Détection par le TITRE : `productType` est vide sur tout le catalogue
         (vérifié le 30/08), et la collection « vestes » utilise déjà cette même
         règle depuis le 22/08. Deux méthodes de détection finiraient par se
         contredire sur un produit limite. */
    var badge = root.querySelector('[data-sj-badge]');
    if (badge) {
      var estVeste = /veste/i.test((product && product.title) || '');
      var t = estVeste ? badge.dataset.badgeVeste : badge.dataset.badgeMaillot;
      if (t) badge.textContent = t;
    }

    if (elPrice) elPrice.textContent = fmt(affiche);
    if (elCompare) elCompare.textContent = plein > affiche ? fmt(plein) : '';
    if (elAddPrice) elAddPrice.textContent = fmt(affiche);
    if (elAddCompare) elAddCompare.textContent = plein > affiche ? fmt(plein) : '';

    majApercu();
  }

  if (elAdd) elAdd.addEventListener('click', addSame);
  /* Le « + » de la carte ajoute SANS flocage — c'est le chemin rapide, et il
     est éteint dès que le panneau est ouvert (voir ouvrirPan). */
  if (elPlus) elPlus.addEventListener('click', addSame);
  /* Un seul écouteur sur la rangée : elle est réécrite à chaque changement,
     donc des écouteurs posés sur les vignettes seraient perdus au 1er rendu. */
  if (elRangee) elRangee.addEventListener('click', function (e) {
    var t = e.target.closest('[data-sj-tuile]');
    if (t) { openGrid(); return; }
    var v = e.target.closest('[data-sj-vig]');
    if (v) choisir(v.getAttribute('data-sj-vig'));
  });
  if (elToggle) elToggle.addEventListener('click', function () {
    ouvrirPan(elToggle.getAttribute('aria-expanded') !== 'true');
  });
  if (elNumber) elNumber.addEventListener('input', function () {
    elNumber.value = elNumber.value.replace(/[^0-9]/g, '').slice(0, 3);
  });
  [elName, elNumber, elBelow].forEach(function (el) {
    if (el) el.addEventListener('input', majApercu);
  });

  /* ⚠️ ON VÉRIFIE CE QU'ON LIT, ET C'EST UNE COURSE MESURÉE LE 20/08.
       Le chemin optimiste du tiroir met le compteur `[data-cart-count]` à jour
       AVANT que le serveur ait la nouvelle quantité. L'observateur voit donc
       le badge bouger et déclenche une lecture de `/cart.js` qui rend encore
       l'ANCIEN panier : l'offre se retrouve avec un cran de retard — VISIBLE à
       2 articles, MASQUÉE à 1, c'est-à-dire l'exact inverse de sa règle.
       Et rien ne la corrige ensuite : le badge ne bouge plus, donc
       l'observateur ne se redéclenche jamais. Mesuré : l'état faux tenait
       encore après 4 secondes.
     ➜ On compare le panier lu au compteur AFFICHÉ, et on relit tant que les
       deux divergent — trois essais, 300 ms d'écart. Une lecture qui contredit
       ce que l'écran montre est une lecture trop tôt, pas une vérité. */
  function refreshFromServer(essai) {
    essai = essai || 0;
    return fetch(rootPath + 'cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var badge = document.querySelector('[data-cart-count]');
        var affiche = badge ? parseInt(badge.textContent.trim(), 10) : NaN;
        if (essai < 3 && !isNaN(affiche) && cart.item_count !== affiche) {
          return new Promise(function (res) { setTimeout(res, 300); })
            .then(function () { return refreshFromServer(essai + 1); });
        }
        refresh(cart);
      })
      /* ⛔ UN ÉCHEC DE LECTURE MASQUE L'OFFRE — 30/08, trouvé par LUI :
           « quand j'avais 2 fois le même maillot dans le panier, ça me proposait
             encore l'offre 2 maillots »
         Ce catch avalait TOUT en silence. Si /cart.js échoue — un 429, une
         coupure — le bloc gardait l'état de la lecture d'AVANT : visible, avec
         le panier à 1, alors que le panier était déjà à 2. Et rien ne le
         corrigeait ensuite : aucune autre lecture n'était déclenchée, le badge
         ne bougeait plus, l'observateur ne se redéclenchait jamais.
         Une offre qui promet un prix sur un panier qu'on ne connaît plus est un
         prix inventé. Dans le doute on la retire : ne rien proposer coûte une
         vente, en proposer une fausse coûte la confiance. */
      .catch(function () { root.setAttribute('hidden', ''); });
  }

  document.addEventListener('cart:refresh', function (e) {
    var cart = e && e.detail && e.detail.cart;
    if (cart) { refresh(cart); return; }
    refreshFromServer();
  });

  /* `cart:refresh` n'est PAS émis sur tous les chemins d'ajout : un quick-add
     passe par window.__onixRefreshCart, qui re-rend le tiroir sans lever
     l'événement. Sans filet, un client arrivé avec un panier vide puis ajoutant
     un maillot ne voyait JAMAIS le bloc « 2e maillot » — le cas le plus courant.

     On observe le TIROIR (stable) et on RE-INTERROGE le badge à chaque mutation :
     garder une référence au nœud du badge ne marche pas, il est remplacé à chaque
     rendu et l'observer se retrouve posé sur un élément détaché.
     Pas de boucle : on ne refetch que si le compte a réellement changé, et nos
     propres écritures (attribut hidden) laissent ce compte identique. */
  var drawerRoot = document.querySelector('[data-cart-drawer-root]');
  if (drawerRoot) {
    var lastCount = null;
    var settle = null;
    new MutationObserver(function () {
      var badge = document.querySelector('[data-cart-count]');
      var cur = badge ? badge.textContent.trim() : null;
      if (cur === null || cur === lastCount) return;
      lastCount = cur;
      clearTimeout(settle);
      settle = setTimeout(refreshFromServer, 250); /* laisse /cart.js se stabiliser */
    }).observe(drawerRoot, { childList: true, subtree: true, characterData: true });
  }

  /* état initial */
  refreshFromServer();
})();
